<template>
  <div class="container">
    <div class="zero-main-top flex flex-cloum">
      <div class="flex align-items space-between">
        <div class="zert-top-left flex align-items">
          <div class="zero-top-img">
            <img v-lazy="iconImg" alt="" />
          </div>
          <div class="zero-top-text">
            <div>免单卡</div>
            <div class="count">
              <span class="fs-34">{{ getTabBarZeroBadge.TotalFreeCardNum }}</span> 张
            </div>
          </div>
        </div>
        <div class="zero-top-btn" @click="checkCardDetail">查看明细</div>
      </div>
      <div class="zero-top-btm-btn" @click="getMoreFreeCard">
        获取更多免单卡
        <!-- <div
          class="zero-badge"
          :class="{'zero-badge-big': getTabBarZeroBadge.WaitGetFreeCardNum > 99}"
          v-if="getTabBarZeroBadge.WaitGetFreeCardNum > 0">{{getTabBarZeroBadge.WaitGetFreeCardNum > 99 ? '99+' : getTabBarZeroBadge.WaitGetFreeCardNum}}
        </div> -->
        <soho-badge :number="getTabBarZeroBadge.WaitGetFreeCardNum" class="numTag"></soho-badge>
      </div>
    </div>
    <time-scrroll ref="timeScroll" :time-list="timeList" :time-index="currentTimeIndex" @timeScrollClick="timeScrollClick"> </time-scrroll>
    <!-- 限时抢购 -->
    <!-- <flash-sale
      v-if="isCurrentTime !== 'flashSale' && flashSaleDataList.length > 0"
      :data-list="flashSaleDataList"
      :flash-list-index="timeList.length"
      :remain-time="residueTime"
      @entoDetailPage="convertShop"
      @goFlashSaleList="goFlashSaleList">
    </flash-sale> -->
    <!-- 筛选 -->
    <filter-radio ref="filterRadioRef" :is-fixed="isFixed" :is-current-time="isCurrentTime" @filterChange="filterChange" @platformChange="platformChange"> </filter-radio>
    <!-- 内容 -->
    <div class="zero-list-cnt">
      <template v-if="isCurrentTime === true">
        <souhuo-list
          :data-list="dataList"
          :is-fake-data="isFakeSkeleton"
          :is-newcomer="isNewcomer"
          :show-head="false"
          :scroll-disabled="scrollDisabled"
          @loadMore="loadMore"
          @entoDetailPage="convertShop"
        >
        </souhuo-list>
        <segement-Line v-if="!haveMore && dataList.length > 0" line-text="没有更多商品啦"></segement-Line>
        <segement-Line v-if="haveMore" :is-load="true" line-text="正在加载"></segement-Line>
        <segement-line v-if="dataList.length <= 0" line-text="暂无相关商品"></segement-line>
      </template>
      <!-- 热销商品模块 → 上个版本为【限时抢购】模块 -->
      <template v-else-if="isCurrentTime === 'flashSale'">
        <template v-if="flashSaleListDataList.length > 0">
          <flash-sale-list :data-list="flashSaleListDataList" :scroll-disabled="scrollDisabled" :is-newcomer="isNewcomer" @loadMore="loadMore"> </flash-sale-list>
          <segement-Line v-if="!haveMore" line-text="没有更多商品啦"></segement-Line>
          <segement-Line v-else :is-load="true" line-text="正在加载"></segement-Line>
        </template>
        <segement-line v-else line-text="暂无热销商品"></segement-line>
      </template>
      <!-- 不是当前节点(未来节点)横向显示列表 -->
      <template v-else>
        <template v-if="dataList.length > 0">
          <row-list
            :data-list="dataList"
            :scroll-disabled="scrollDisabled"
            :time-list="timeList"
            :time-index="currentTimeIndex"
            :is-newcomer="isNewcomer"
            @loadMore="loadMore"
            @remindMe="remindMe"
            @cancelRemind="cancelRemind"
            @setRemindResSucessHandler="setRemindResSucessHandler"
          >
          </row-list>
          <segement-Line v-if="!haveMore" line-text="没有更多商品啦"></segement-Line>
          <segement-Line v-else :is-load="true" line-text="正在加载"></segement-Line>
        </template>
        <!-- 无商品 -->
        <div class="no-more-goods" v-if="!scrollDisabled && dataList.length <= 0">
          <div class="no-more-img">
            <img src="@/assets/image/superman.png" alt="暂无商品" />
          </div>
          <p>商品正在努力准备中...</p>
          <p>先去逛逛鸭~</p>
        </div>
      </template>
    </div>
    <!-- 返回顶部 -->
    <quick-top @returnTop="returnTop" :isReturn="isReturn" :positionBtm="80"></quick-top>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
import zeroBuyMixins from './mixins/zeroBuyMixins'

export default {
  name: 'ZeroBuyMain',
  mixins: [zeroBuyMixins],
  data() {
    return {
      isNewcomerPage: false, // 是否是新人页面，用于后端限制查询
      iconImg: IMG_BASE_URL + '/upaiyun/Sys/20181217/4737334625133973679.png'
    }
  },
  methods: {
    // 查看免单卡明细
    checkCardDetail: function() {
      this.checkLogin(() => {
        this.$router.push({
          name: 'freeCardDetail'
        })
      })
    },
    // 获取更多免单卡
    getMoreFreeCard() {
      this.$router.push({
        name: 'collarCartCenter'
      })
    },
    setRemindResSucessHandler(optIdx) {
      this.dataList[optIdx].IsPrePurchase = !this.dataList[optIdx].IsPrePurchase
    }
  }
}
</script>

<style scoped>
@import '../zeroBuy.css';
.zero-list-cnt {
  padding-bottom: 15%;
}
.zero-main-top {
  padding: 10px 10px;
}
.zero-top-btm-btn {
  margin-top: 10px;
}
.numTag {
  position: absolute;
  top: 9px;
  right: 80px;
}
.no-more-goods {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #999;
  margin-top: 30%;
}
.no-more-img {
  width: 100px;
  height: 100px;
}
.no-more-img img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
